var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40542",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1657",
    d: "M18.36 4.199a1.386 1.386 0 00-1.44 1.44 1.44 1.44 0 102.88 0 1.386 1.386 0 00-1.44-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1658",
    d: "M12 5.88A6.12 6.12 0 1018.12 12 6.146 6.146 0 0012 5.88zm0 10.08A3.96 3.96 0 1115.96 12 4 4 0 0112 15.96z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1656",
    d: "M23.88 7.08C23.64 2.76 21.24.36 16.92.12h-.12A40.446 40.446 0 0012 0a44.317 44.317 0 00-4.92.12h-.12C2.64.36.12 2.76 0 7.08V12a43.033 43.033 0 00.12 4.92c.24 4.32 2.64 6.84 6.96 6.96 1.2 0 1.56.12 4.92.12a41.757 41.757 0 004.92-.12c4.32-.24 6.72-2.64 6.96-6.96 0-1.32.12-1.8.12-4.92a45.618 45.618 0 00-.12-4.92zm-2.16 9.72a5.541 5.541 0 01-1.32 3.6 5.541 5.541 0 01-3.6 1.32c-1.32 0-1.68.12-4.8.12a41.7 41.7 0 01-4.8-.12c-3.24-.12-4.8-1.68-4.92-4.92a42.954 42.954 0 01-.12-4.8 40.443 40.443 0 01.12-4.8A4.972 4.972 0 013.6 3.6a5.541 5.541 0 013.6-1.32c1.32 0 1.68-.12 4.8-.12a41.7 41.7 0 014.8.12c3.24.12 4.8 1.68 4.92 4.92 0 1.2.12 1.56.12 4.8a40.448 40.448 0 01-.12 4.8z"
  }))));
}
export default SvgInstagram;